import { defineStore } from 'pinia';
import  { ref, computed } from 'vue';
import { useEventListener } from '@vueuse/core';

export const useAppStore = defineStore('app', {
    state: () => ({
        language: 'en', // default language
    }),
    getters: {
        getLanguage() {
            return this.language;
        },
    },
    actions: {
        setLanguage(newLanguage) {
            this.language = newLanguage;
        },
        createIssue({name, email, message}) {
            // https POST call to redmine
            fetch('https://redmine.go-cybernation.cloud/issues.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Redmine-API-Key': "0b1cefd26a1fe6286d9a1912f86c1ae2edc5dd11",
                },
                body: JSON.stringify({
                    issue: {
                        project_id: 18,
                        subject: `Website contact from ${name}`,
                        description: `Email: ${email}\n\n${message}`,
                        priority_id: 1
                    }
                })
            })
            
        },
    }
});

export const useScreenStore = defineStore('screen', () => {
    const width = ref(0);
    const height = ref(0);

    const updateSize = () => {
        if (typeof window !== 'undefined') {
            width.value = window.innerWidth;
            height.value = window.innerHeight;
        }
    };

    useEventListener(document, 'resize', updateSize);

    const isMobile = computed(() => width.value < 768);
    const isTablet = computed(() => width.value >= 768 && width.value < 1024);
    const isDesktop = computed(() => width.value >= 1024);

    return {
        width,
        height,
        isMobile,
        isTablet,
        isDesktop,
    };
});
